import { LocalStoreType } from "../constants/local-type";
import { getDataLocal } from "../Helper/localStoreFunction";

export const UpdateRole = async (formData: any, items: any) => {
  const data = {
    role: formData,
    formRoleEmployee: items,
  };
  const respone = await fetch("api/Roles/UpdateRole", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {});

  return respone;
};

export const GetRolePermissionByUser = async () => {
  const respone = await fetch("api/Roles/GetRolePermissionByUser")
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {});

  return respone;
};

export const UserPermissionsByRoleID = async (roleid: any) => {
  const respone = await fetch(`api/Roles/UserPermissionsByRoleID/${roleid}`)
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {});
  return respone;
};

export const GetPermissionByEmpId = async (data: any) => {
  const email = getDataLocal(LocalStoreType.email) || "";
  data.UserPrincipalName = email;
  const respone = await fetch("api/Roles/GetPermissionByEmpId", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {});
  return respone;
};
